export default __webpack_public_path__ + "static/media/ronnie.e590ba83.mp3";